import { render, staticRenderFns } from "./ExpenseHeads.vue?vue&type=template&id=0771f332"
import script from "./ExpenseHeads.vue?vue&type=script&lang=js"
export * from "./ExpenseHeads.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports